import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Page, View, Text, Svg, Line, StyleSheet } from '@react-pdf/renderer';
import dayjs from 'dayjs';
import { HeaderImage } from '../Shared';
import { Entry } from './components';
import CapitalDrug from '../../../../images/capital-drug-logo.png';
;
export const DocumentFour = memo(({ pharmacy, traderInfo, }) => {
    const row = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
    const disclaimer = {
        margin: '12px 0px 20px',
        fontSize: 10,
        lineHeight: 1.75,
    };
    const styles = StyleSheet.create({
        container: {
            padding: '30px 60px',
        },
        titleContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '30px 0px',
            width: '100%',
        },
        title: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            fontSize: 15,
        },
        entryContainer: {
            ...row,
            marginBottom: 12,
        },
        disclaimer,
        disclaimer2: {
            ...disclaimer,
            lineHeight: 1,
            fontSize: 9,
            margin: '8px auto 0px',
            whiteSpace: 'nowrap',
        },
        signatureContainer: {
            ...row,
            marginTop: 36,
        },
        signatureContainer2: {
            ...row,
            marginTop: 24,
        },
        signaturesDivider: {
            margin: '80px 0px 0px',
            borderTop: '2px solid #333',
            width: '100%',
            textAlign: 'center',
        },
        footer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 110,
        },
        footerRow1: {
            ...row,
            justifyContent: 'center',
        },
        footerRow2: {
            marginTop: 6,
        },
        footerText: {
            fontFamily: 'Roboto',
            fontStyle: 'bold',
            fontWeight: 700,
            fontSize: 10,
        },
    });
    const { owner, } = traderInfo;
    const date = dayjs().format('MM/DD/YYYY');
    return (_jsx(Page, { size: 'A4', wrap: false, children: _jsxs(View, { style: styles.container, children: [_jsx(HeaderImage, { imgSrc: CapitalDrug }), _jsx(View, { style: styles.titleContainer, children: _jsx(Text, { style: styles.title, children: "Purchasing Directive Authorization Form" }) }), _jsxs(View, { style: styles.entryContainer, children: [_jsx(Entry, { label: 'Customer Name:', value: `${owner.firstName} ${owner.lastName}` }), _jsx(Entry, { label: 'Customer Number:', value: '______________' })] }), _jsx(View, { style: styles.entryContainer, children: _jsx(Entry, { label: 'Customer Address:', value: `${pharmacy.address}, ${pharmacy.city}, ${pharmacy.state} ${pharmacy.zipCode}` }) }), _jsx(Text, { style: styles.disclaimer, children: "By signing below, I am authorizing Capital Wholesale Drug & Co. (\"Capital Drug\") to assign my purchasing activity and/or contract from my current servicer to the new servicer listed. By signing this form, I understand that all activity with my current servicer will be suspended through Capital Drug when transitioning to my new servicer." }), _jsx(View, { style: styles.entryContainer, children: _jsx(Entry, { label: 'Current Servicer:', value: '____________________________________________________' }) }), _jsx(View, { style: styles.entryContainer, children: _jsx(Entry, { label: 'New Servicer:', value: 'Pharmacy Marketplace, LLC' }) }), _jsx(View, { style: styles.entryContainer, children: _jsx(Entry, { label: 'Effective Date:', value: date }) }), _jsxs(View, { style: styles.signatureContainer, children: [_jsx(Entry, { label: 'Customer Signature:', value: '                 ' }), _jsx(Entry, { label: 'Date:', value: '                                    ' })] }), _jsx(View, { style: styles.signaturesDivider, children: _jsx(Text, { style: styles.disclaimer2, children: "All purchasing directive changes require the execution of this form by an authorized representative of Capital Drug." }) }), _jsxs(View, { style: styles.signatureContainer2, children: [_jsx(Entry, { label: 'Capital Drug Authorized Signature:', value: '_________________________' }), _jsx(Entry, { label: 'Date:', value: '____________' })] }), _jsxs(View, { style: styles.footer, children: [_jsxs(View, { style: styles.footerRow1, children: [_jsx(Text, { style: styles.footerText, children: "1-800-525-0022" }), _jsx(Svg, { height: '20', width: '12', children: _jsx(Line, { x1: '6', y1: '4', x2: '6', y2: '15', strokeWidth: 1, stroke: 'rgb(255,0,0)' }) }), _jsx(Text, { style: styles.footerText, children: "www.capital-drug.com" })] }), _jsx(View, { style: styles.footerRow2, children: _jsx(Text, { style: styles.footerText, children: "873 Williams Ave. Columbus, OH 43212" }) })] })] }) }));
});
